import {
  Box,
  Collapse,
  Divider,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import useDynamicData from '../../../../hooks/template/useDynamicData';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

export const DataPanel = ({ onClick }) => {
  const theme = useTheme();
  const { dynDatas } = useDynamicData({});
  const [contactDataList, setContactDataList] = useState([]);
  const [ticketDataList, setTicketDataList] = useState([]);
  const [orderDataList, setOrderDataList] = useState([]);
  const [ticketOpen, setTicketOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  const [orderOpen, setOrderOpen] = useState(false);

  useEffect(() => {
    const ticketList = [];
    const contactList = [];
    const orderList = [];
    dynDatas?.map((data) => {
      const origin = data?.path?.split('.');
      if (data?.source === 'ORDER' || origin[0] === 'order') {
        orderList.push(data);
      } else if (origin[0] === 'contact') {
        contactList.push(data);
      } else {
        ticketList.push(data);
      }
    });
    setOrderDataList(orderList);
    setContactDataList(contactList);
    setTicketDataList(ticketList);
  }, [dynDatas]);

  return (
    <Box
      sx={{
        minWidth: '40%',
        borderLeft: `4px solid ${theme.palette.borders.main}`,
        padding: 2,
        backgroundColor: theme.palette.background.note.TASKCREATED,
      }}
    >
      <Typography color="primary" variant="h6" sx={{ fontWeight: 'bold' }}>
        Données dynamiques :
      </Typography>
      <List sx={{ width: '100%' }}>
        {/* Données du ticket */}
        <ListItemButton
          onClick={() => setTicketOpen(!ticketOpen)}
          color="primary"
        >
          <ListItemText primary="Données du ticket" />
          {ticketOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={ticketOpen} timeout="auto" unmountOnExit>
          <Divider sx={{ mb: 2 }} />
          <List component="div" disablePadding>
            {ticketDataList?.map((ticketData) => (
              <ListItemButton
                sx={{ pl: 4 }}
                key={ticketData?._id}
                onClick={() => onClick(ticketData)}
              >
                <Box
                  sx={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography fontWeight="bold">
                    {ticketData?.description}
                  </Typography>
                  <Typography color="primary">{`{{${ticketData?.label}}}`}</Typography>
                </Box>
              </ListItemButton>
            ))}
          </List>
        </Collapse>
        <Divider sx={{ mb: 2 }} />

        {/* Données du client */}
        <ListItemButton
          onClick={() => setContactOpen(!contactOpen)}
          color="primary"
        >
          <ListItemText primary="Données du client" />
          {contactOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={contactOpen} timeout="auto" unmountOnExit>
          <Divider sx={{ mb: 2 }} />

          <List component="div" disablePadding>
            {contactDataList?.map((contactData) => (
              <ListItemButton
                sx={{ pl: 4 }}
                key={contactData?._id}
                onClick={() => onClick(contactData)}
              >
                <Box
                  sx={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography fontWeight="bold">
                    {contactData?.description}
                  </Typography>
                  <Typography color="primary">{`{{${contactData?.label}}}`}</Typography>
                </Box>
              </ListItemButton>
            ))}
          </List>
        </Collapse>
        <Divider sx={{ mb: 2 }} />

        {/* Données de la commande */}
        <ListItemButton
          onClick={() => setOrderOpen(!orderOpen)}
          color="primary"
        >
          <ListItemText primary="Données de la commande" />
          {orderOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={orderOpen} timeout="auto" unmountOnExit>
          <Divider sx={{ mb: 2 }} />

          <List component="div" disablePadding>
            {orderDataList?.map((orderData) => (
              <ListItemButton
                sx={{ pl: 4 }}
                key={orderData?._id}
                onClick={() => onClick(orderData)}
              >
                <Box
                  sx={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography fontWeight="bold">
                    {orderData?.description}
                  </Typography>
                  <Typography color="primary">{`{{${orderData?.label}}}`}</Typography>
                </Box>
              </ListItemButton>
            ))}
          </List>
        </Collapse>
      </List>
    </Box>
  );
};
